import $ from 'jquery';

export default function () {
	function displayFormElements(type) {
		$('.tier-type').addClass('hidden');
		$('.tier-type-' + type).removeClass('hidden');
	}

	$('select#type').on('change', function () {
		displayFormElements($(this).val());
	});

	displayFormElements($('select#type').val());
}
